import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const GET_PARTIAL_USER_QUERY = gql`
  query ($id: ID!) {
    getPartialUser(id: $id) {
      firstName
      lastName
      email
      countryCode
      phoneNumber
      guestUserType
    }
  }
`

export interface PartialUser {
  firstName: string
  lastName: string
  email: string
  countryCode: string
  phoneNumber: string
  /** 'guest' | 'placeholder' for checkout guests; null for legacy temp-pass
   *  users created on someone's behalf (the force-registration audience). */
  guestUserType: string | null
}

interface GetPartialUserQueryResponse {
  getPartialUser: PartialUser
}

export const useGetPartialUserApi = (id: string | null): UseQueryResult<PartialUser, Error> => {
  const client = useGraphQLClient()

  const fetchPartialUser = async (id: string | null): Promise<PartialUser> => {
    const data = await client.request<GetPartialUserQueryResponse>(GET_PARTIAL_USER_QUERY, {
      id,
    })

    return data.getPartialUser
  }

  return useQuery<PartialUser, Error>({
    queryKey: [id],
    enabled: !!id,
    queryFn: () => fetchPartialUser(id),
  })
}
